import { StepIconProps } from './StepIcon.props';
import { IconCheck, IconCircle, IconContainer, IconSkeleton } from './StepIcon.styles';
import { StepStatus } from '../ValuationStatusTracker.types';

const StepIcon = ({ status, isLoading = false }: StepIconProps) => {
  const getIconContent = () => {
    if (isLoading) {
      return <IconSkeleton variant="circular" animation="wave" />;
    }

    switch (status) {
      case StepStatus.COMPLETED:
        return <IconCheck />;
      case StepStatus.ACTIVE:
        return <IconCircle color="primary" />;
      case StepStatus.PENDING:
        return <IconCircle style={{ color: 'white' }} />;
      default:
        return <IconCircle style={{ color: 'white' }} />;
    }
  };

  return <IconContainer className={status}>{getIconContent()}</IconContainer>;
};

export default StepIcon;
